// Modalita' del tenant: le licenze sono Balanced oppure Direct, mai entrambe.
// -> "direct" | "balanced" | "none" | null (dati non ancora caricati)
export const tenantMode = (modeDetails) => {
  if (
    modeDetails === undefined ||
    modeDetails === null ||
    modeDetails.balanced_licenses === null ||
    modeDetails.balanced_licenses === undefined
  ) {
    return null;
  }
  if (modeDetails.direct_licenses === true) {
    return "direct";
  }
  if (modeDetails.balanced_licenses === true) {
    return "balanced";
  }
  return "none";
};
